/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AcceptContractTermsRequest } from './';
import {
    AcceptContractTermsRequestFromJSON,
    AcceptContractTermsRequestFromJSONTyped,
    AcceptContractTermsRequestToJSON,
} from './';
import type { InvoicingMode } from './';
import {
    InvoicingModeFromJSON,
    InvoicingModeFromJSONTyped,
    InvoicingModeToJSON,
} from './';

/**
 * 
 * @export
 * @interface AcceptTripartiteContractTermsRequest
 */
export interface AcceptTripartiteContractTermsRequest extends AcceptContractTermsRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptTripartiteContractTermsRequest
     */
    projectTermsId: string;
}

/**
 * Check if a given object implements the AcceptTripartiteContractTermsRequest interface.
 */
export function instanceOfAcceptTripartiteContractTermsRequest(value: object): value is AcceptTripartiteContractTermsRequest {
    if (!('projectTermsId' in value) || value['projectTermsId'] === undefined) return false;
    return true;
}

export function AcceptTripartiteContractTermsRequestFromJSON(json: any): AcceptTripartiteContractTermsRequest {
    return AcceptTripartiteContractTermsRequestFromJSONTyped(json, false);
}

export function AcceptTripartiteContractTermsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptTripartiteContractTermsRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...AcceptContractTermsRequestFromJSONTyped(json, ignoreDiscriminator),
        'projectTermsId': json['projectTermsId'],
    };
}

export function AcceptTripartiteContractTermsRequestToJSON(value?: AcceptTripartiteContractTermsRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...AcceptContractTermsRequestToJSON(value, true),
        'projectTermsId': value['projectTermsId'],
    };
}

